import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Programs from './pages/Programs';
import GetInvolved from './pages/GetInvolved';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import DonationsPolicy from './pages/DonationsPolicy';
import VolunteerCode from './pages/VolunteerCode';
import ThankYou from './pages/ThankYou';
import './App.css';

const SITE_ORIGIN = 'https://delinamfoundation.org';

function RouteMetadata() {
  const { pathname } = useLocation();

  useEffect(() => {
    const canonicalUrl = `${SITE_ORIGIN}${pathname === '/' ? '/' : pathname}`;
    const canonical = document.querySelector('link[rel="canonical"]');
    const ogUrl = document.querySelector('meta[property="og:url"]');

    if (canonical) canonical.setAttribute('href', canonicalUrl);
    if (ogUrl) ogUrl.setAttribute('content', canonicalUrl);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <RouteMetadata />
      <div className="App">
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/programs" element={<Programs />} />
            <Route path="/get-involved" element={<GetInvolved />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/donations-policy" element={<DonationsPolicy />} />
            <Route path="/volunteer-code" element={<VolunteerCode />} />
            <Route path="/thank-you" element={<ThankYou />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" richColors />
      </div>
    </BrowserRouter>
  );
}

export default App;
